export const OrganizationBillingStatus = {
  Evaluation: "evaluation",
  Billable: "billable",
  UpgradeRequested: "upgrade_requested",
} as const

export type OrganizationBillingStatus = typeof OrganizationBillingStatus[keyof typeof OrganizationBillingStatus]
